export default "__VITE_ASSET__C1BduX8l__"